import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { FieldErrorDisplayModule } from '../../shared/field-error-display/field-error-display.module';
import { SharedModule } from '../../shared/shared.module';
import { SignUpComponent } from './sign-up.component';
import { SignUpOrganizationResolver } from './sign-up-organization.resolver';
import { ButtonModule } from '../../shared/button/button.module';
import { PrivacyPolicyDialogModule } from '../../shared/privacy-policy-dialog/privacy-policy-dialog.module';
import { TermsOfServiceDialogModule } from '../../shared/terms-of-service-dialog/terms-of-service-dialog.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { StringValidatorsModule } from '../../../directives/validators/string/string-validators.module';
import { ComparisonValidatorsModule } from '../../../directives/validators/comparison/comparison-validators.module';
import { RecaptchaModule } from 'ng-recaptcha';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule } from 'ngx-mask';
import { MatStepperModule } from '@angular/material/stepper';
import { MaterialSearchModule } from '../../shared/material-search/material-search.module';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { GeoRegionSelectorModule } from '../../shared/geo-region-selector/geo-region-selector.module';
import { MatMenuModule } from '@angular/material/menu';
import { SignUpParamsResolver } from './sign-up-params.resolver';
import { LoginFormModule } from '../login/login-form/login-form.module';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Routing
        RouterModule.forChild([
            {
                path: '',
                component: SignUpComponent,
                resolve: {
                    organization: SignUpOrganizationResolver,
                    params: SignUpParamsResolver,
                },
            },
            {
                path: ':org_url',
                component: SignUpComponent,
                resolve: {
                    organization: SignUpOrganizationResolver,
                },
            },
        ]),
        PrivacyPolicyDialogModule,
        TermsOfServiceDialogModule,
        ButtonModule,
        FieldErrorDisplayModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        StringValidatorsModule,
        ComparisonValidatorsModule,
        RecaptchaModule,
        MatInputModule,
        NgxMaskModule,
        MatIconModule,
        MatStepperModule,
        MaterialSearchModule,
        MatGoogleMapsAutocompleteModule,
        MatRadioModule,
        GeoRegionSelectorModule,
        MatMenuModule,
        LoginFormModule,
    ],
    declarations: [SignUpComponent],
    providers: [],
})
export class SignUpModule
{
}
